import React from 'react';
import {
  Button, Dialog, DialogActions, DialogTitle,
} from '@mui/material';

class BulkClose extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    };
  }

  render() {
    const {
      open, handleSave, handleClose, message,
    } = this.props;

    return (
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
        >
          <DialogTitle>{message}</DialogTitle>
          <DialogActions>
            <Button onClick={handleClose} color="secondary">
              Cancel
            </Button>
            <Button onClick={() => handleSave()} color="primary">
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default BulkClose;
